var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoonImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.61845 0.000653856C2.48469 0.200869 0 2.8125 0 5.99445C0 9.30677 2.69323 12 6.00553 12C8.87281 12 11.2767 9.98222 11.8703 7.28862C11.89 7.20382 11.8795 7.11482 11.8408 7.03686C11.8021 6.9589 11.7374 6.89682 11.658 6.86125C11.5785 6.82568 11.4892 6.81883 11.4052 6.84188C11.3213 6.86492 11.248 6.91642 11.1978 6.98757C10.4241 8.05155 9.17487 8.747 7.75714 8.747C5.40333 8.747 3.50323 6.84688 3.50323 4.49307C3.50323 2.84171 4.44307 1.41444 5.81395 0.708337C5.89017 0.66865 5.95047 0.604014 5.98477 0.525223C6.01907 0.446432 6.0253 0.358259 6.00242 0.275428C5.97954 0.192596 5.92893 0.120124 5.85904 0.0701148C5.78916 0.0201058 5.70423 -0.00441508 5.61845 0.000653856ZM4.06624 1.1306C3.25554 2.02019 2.75253 3.19712 2.75253 4.49307C2.75253 7.25259 4.99763 9.4977 7.75714 9.4977C8.7802 9.4977 9.73191 9.18592 10.5253 8.65707C9.61211 10.2047 7.93612 11.2493 6.00553 11.2493C3.09893 11.2493 0.750691 8.90106 0.750691 5.99445C0.750691 3.77738 2.12818 1.90364 4.06624 1.1306Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonImg);
export default __webpack_public_path__ + "static/media/moonImg.0dc5ffa17baa5780e4a3d0a95090b1d2.svg";
export { ForwardRef as ReactComponent };